import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=bc0f9f7e"
import script from "./Messaging.vue?vue&type=script&lang=ts"
export * from "./Messaging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports